import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import api from '../middleware/api'
import googleTagManagerMiddleware from '../middleware/googleTagManagerMiddleware'
import rootReducer from '../reducers'

const configureStore = preloadedState => {
	const store = createStore(
		rootReducer,
		preloadedState,
		compose(applyMiddleware(thunk, api, googleTagManagerMiddleware)),
	)
	return store
}

export default configureStore



// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js